<template>
    <div class="language_selector">
        <select
            name="languageselect"
            @change="selectLanguage"
            v-model="tempSelectedLanguageId"
            
        >
            <option
                v-for="language in languagesToSelect"
                :key="language._id"
                :value="language._id"
            >
                {{ language.name }}
            </option>
        </select>
        <a
            v-show="!allLanguages && !nonexistingLanguagesIsEmpty"
            class="btn btn_grey btn_dropdown"
            :class="{ 'active': isAddLanguageOpen }"
            :title="translations.addLanguage"
            v-translate
            @click="isAddLanguageOpen = !isAddLanguageOpen"
        >Přidat jazyk</a>
        <div class="dropdown_content" :class="{ 'open': isAddLanguageOpen }">
            <ul>
                <app-radio-button
                    v-for="language in nonexistingLanguages"
                    labels
                    :title="language.name"
                    :key="language._id"
                    v-model="selectedRadioBtn"
                    :value="language"
                    :name="language.name"
                />
            </ul>
            <p class="field">
                <input class="btn" type="submit" :value="translations.add" @click.prevent="addLanguage(selectedRadioBtn)">
            </p>
        </div>

        <a v-if="!isNewItem && $auth.check('ROLE_ADMIN')"
            class="btn btn_orange"
            :title="translations.addLanguage"
            v-translate
            @click="createBlackoutContentTemplate"
        >Vytvořit blokovací šablonu</a>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: 'show-language-select',
    props: {
        existingLanguagesIds: {
            type: Array,
            default() {
                return []
            }
        },
        selectedLanguageId: {
            type: Number,
            default: null
        },
        allLanguages: {
            type: Boolean,
            default: false
        },
        isNewItem: {
            type: Boolean,
            default: true,
        }
    },
    created() {
        this.getLanguagesForCurrentLanguage()
        this.tempSelectedLanguageId = this.selectedLanguageId
    },
    data() {
        return {
            isAddLanguageOpen: false,
            selectedRadioBtn: null,
            tempSelectedLanguageId: null,
        }
    },
    computed: {
        ...mapState({
            languages: state => state.languages.languages,
            uiLanguageId: state => state.uiLanguages.currentLanguageId
        }),
        translations() {
          return {
            addLanguage: this.$gettext('Přidat jazyk'),
            add: this.$gettext('Přidat'),
          }
        },
        languagesToSelect() {
            if (this.allLanguages) {
                return this.languages
                    .reduce((obj, v) => {
                        obj[v._id] = {
                            _id: v._id,
                            name: v.languageName
                        }
                        return obj
                    }, {})
            } else {
                return this.existingLanguages
            }
        },
        existingLanguages() {
            return this.languages
                .filter(v => this.existingLanguagesIds.includes(v._id) || v._id === this.tempSelectedLanguageId )
                .reduce((obj, v) => {
                    obj[v._id] = {
                        _id: v._id,
                        name: v.languageName
                    }
                    return obj
                }, {})
        },
        nonexistingLanguages() {
            return this.languages
                .filter(v => !this.existingLanguagesIds.includes(v._id) && v._id !== this.tempSelectedLanguageId )
                .reduce((obj, v) => {
                    obj[v._id] = {
                        _id: v._id,
                        name: v.languageName
                    }
                    return obj
                }, {})
        },
        nonexistingLanguagesIsEmpty() {
            return Object.keys(this.nonexistingLanguages).length === 0
        }
    },
    methods: {
        ...mapActions([
            'getLanguages'
        ]),
        createBlackoutContentTemplate() {
            this.$router.push({
                name: 'blackoutContentTemplateNew',
                params: {
                    id: 'new',
                    showId: this.$route.params.id,
                }
            });
        },
        getLanguagesForCurrentLanguage() {
            let promise = this.getLanguages({
                params: {
                    idLanguage: this.uiLanguageId
                }
            })
        },
        addLanguage(addedLanguage) {
            if (addedLanguage !== null) {
                this.tempSelectedLanguageId = addedLanguage._id

                this.isAddLanguageOpen = false
                this.selectedRadioBtn = null

                this.$emit('addLanguage', addedLanguage)
            }
        },
        selectLanguage() {
            this.$emit('selectLanguage', this.tempSelectedLanguageId)
        }
    },
    watch: {
        uiLanguageId() {
            this.getLanguagesForCurrentLanguage()
        },
        selectedLanguageId(id) {
            this.tempSelectedLanguageId = id
        }
    }
}
</script>